import { useEffect, useRef, useState } from "react";
import { getAll, getBySlug } from "../../api/category";
import { RightOutlined } from "@ant-design/icons";

export default function NewCategory() {
    const [categoryMenu, setCategoryMenu] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null);
    const [activeCategoryData, setActiveCategoryData] = useState(null);
    const [loadingCategory, setLoadingCategory] = useState(false);

    const rightColumnRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);

        getAll("page=1&pageSize=100", (res) => {
            const originalData = res?.data || [];

            const nguoiLonTuoi = originalData.filter((item) => {
                const name = (item?.category_name || "")
                    .trim()
                    .toLowerCase();

                return name === "người lớn tuổi";
            });

            const sachTaiLieu = originalData.filter((item) => {
                const name = (item?.category_name || "")
                    .trim()
                    .toLowerCase();

                return (
                    name === "sách and tài liệu" ||
                    name === "sách & tài liệu"
                );
            });

            const danhMucConLai = originalData.filter((item) => {
                const name = (item?.category_name || "")
                    .trim()
                    .toLowerCase();

                return (
                    name !== "người lớn tuổi" &&
                    name !== "sách and tài liệu" &&
                    name !== "sách & tài liệu"
                );
            });

            const sortedData = [
                ...nguoiLonTuoi,
                ...danhMucConLai,
                ...sachTaiLieu
            ];

            setCategoryMenu({
                ...res,
                data: sortedData
            });

            const defaultCategory =
                nguoiLonTuoi?.[0] ||
                sortedData?.[0];

            if (defaultCategory) {
                loadCategory(defaultCategory, false);
            }
        });
    }, []);

    const loadCategory = (item, scrollTop = true) => {
        setActiveCategory(item);
        setLoadingCategory(true);

        if (scrollTop && rightColumnRef.current) {
            rightColumnRef.current.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }

        getBySlug(item?.category_slug, (data) => {
            setActiveCategoryData(data);
            setLoadingCategory(false);
        });
    };

    const formatCategoryName = (name) => {
        if (!name) return "";

        if (
            name.trim().toLowerCase() === "sách and tài liệu"
        ) {
            return "Sách & Tài Liệu";
        }

        return name;
    };

    return (
        <div
            className="
                fixed
                md:relative

                left-0
                right-0

                top-[58px]
                bottom-[66px]

                md:top-auto
                md:bottom-auto

                md:max-w-screen-2xl
                md:mx-auto

                bg-white
                overflow-hidden
            "
        >
            <div
                className="
                    flex
                    w-full
                    h-full

                    md:h-[calc(100vh-150px)]
                    md:min-h-[500px]
                    md:max-h-[720px]

                    bg-white
                    overflow-hidden
                "
            >

                {/* =========================
                    CỘT DANH MỤC BÊN TRÁI
                ========================== */}

                <div
                    className="
                        w-[29%]
                        md:w-[230px]

                        h-full
                        flex-none

                        bg-[#f6f8fb]

                        border-r
                        border-gray-100

                        overflow-y-auto
                        overscroll-contain
                    "
                    style={{
                        WebkitOverflowScrolling: "touch",
                        scrollbarWidth: "none"
                    }}
                >

                    <div
                        className="
                            hidden
                            md:block

                            px-4
                            pt-4
                            pb-3

                            text-[12px]
                            font-semibold
                            tracking-wide
                            text-gray-400
                        "
                    >
                        DANH MỤC
                    </div>

                    {categoryMenu?.data?.map((item, index) => {

                        const isActive =
                            activeCategory?.category_slug ===
                            item?.category_slug;

                        return (
                            <button
                                key={item?.category_slug || index}
                                type="button"
                                onClick={() => loadCategory(item)}
                                className={`
                                    relative
                                    w-full

                                    flex
                                    flex-col
                                    md:flex-row

                                    items-center

                                    gap-1
                                    md:gap-3

                                    px-2
                                    md:px-3

                                    py-3

                                    border-b
                                    border-gray-100

                                    transition-all
                                    duration-200

                                    ${
                                        isActive
                                            ? "bg-[#eef6ff]"
                                            : "bg-transparent hover:bg-white"
                                    }
                                `}
                            >

                                {/* VẠCH XANH ACTIVE */}
                                {isActive && (
                                    <div
                                        className="
                                            absolute
                                            left-0
                                            top-[8px]
                                            bottom-[8px]

                                            w-[3px]

                                            rounded-r-full
                                            bg-[#1677ff]
                                        "
                                    />
                                )}

                                {/* ICON DANH MỤC */}
                                <div
                                    className={`
                                        flex-none

                                        flex
                                        items-center
                                        justify-center

                                        w-[52px]
                                        h-[52px]

                                        rounded-2xl

                                        transition-all
                                        duration-200

                                        ${
                                            isActive
                                                ? "bg-white shadow-sm scale-[1.03]"
                                                : "bg-white"
                                        }
                                    `}
                                >
                                    <img
                                        src={item?.category_image}
                                        alt={item?.category_name}
                                        className="
                                            w-[42px]
                                            h-[42px]

                                            object-contain

                                            rounded-xl
                                        "
                                    />
                                </div>

                                {/* TÊN DANH MỤC */}
                                <div className="flex-1 min-w-0 w-full">

                                    <p
                                        className={`
                                            text-[11px]
                                            md:text-[13px]

                                            leading-[16px]
                                            md:leading-[18px]

                                            line-clamp-2

                                            transition-colors

                                            ${
                                                isActive
                                                    ? "text-[#1677ff] font-bold"
                                                    : "text-gray-700 font-medium"
                                            }
                                        `}
                                    >
                                        {formatCategoryName(
                                            item?.category_name
                                        )}
                                    </p>

                                </div>

                                {isActive && (
                                    <RightOutlined
                                        className="
                                            hidden
                                            md:block

                                            text-[#1677ff]
                                            text-[10px]
                                        "
                                    />
                                )}

                            </button>
                        );
                    })}

                </div>


                {/* =========================
                    DANH MỤC CON BÊN PHẢI
                ========================== */}

                <div
                    ref={rightColumnRef}
                    className="
                        flex-1
                        min-w-0
                        h-full

                        bg-white

                        overflow-y-auto
                        overscroll-contain
                    "
                    style={{
                        WebkitOverflowScrolling: "touch",
                        scrollbarWidth: "none"
                    }}
                >

                    {/* HEADER */}
                    <div
                        className="
                            sticky
                            top-0

                            z-20

                            bg-white/95
                            backdrop-blur-sm

                            border-b
                            border-gray-100

                            px-3
                            md:px-6

                            py-2.5
                            md:py-4
                        "
                    >
                        <div className="flex items-center justify-between">

                            <div className="min-w-0">

                                <p
                                    className="
                                        hidden
                                        md:block

                                        text-[11px]
                                        text-gray-400
                                        mb-1
                                    "
                                >
                                    Khám phá danh mục
                                </p>

                                <h1
                                    className="
                                        text-[14px]
                                        md:text-[20px]

                                        font-bold
                                        text-gray-900

                                        truncate
                                    "
                                >
                                    {formatCategoryName(
                                        activeCategory?.category_name
                                    ) || "Danh mục"}
                                </h1>

                            </div>

                            <span
                                className="
                                    hidden
                                    md:block

                                    text-[11px]
                                    md:text-[12px]

                                    text-gray-400

                                    bg-gray-50

                                    px-2.5
                                    py-1

                                    rounded-full
                                "
                            >
                                {activeCategoryData?.data?.dataChild?.length || 0} mục
                            </span>

                        </div>
                    </div>


                    {/* LOADING */}
                    {loadingCategory ? (

                        <div
                            className="
                                flex
                                flex-col
                                items-center
                                justify-center

                                py-20

                                text-gray-400
                                text-[13px]
                            "
                        >
                            <div
                                className="
                                    w-6
                                    h-6

                                    mb-3

                                    border-2
                                    border-gray-200
                                    border-t-[#1677ff]

                                    rounded-full

                                    animate-spin
                                "
                            />

                            Đang tải danh mục...
                        </div>

                    ) : (

                        /* GRID DANH MỤC CON */
                        <div
                            className="
                                grid

                                grid-cols-3
                                md:grid-cols-4
                                xl:grid-cols-5

                                gap-x-2
                                gap-y-6

                                md:gap-x-4
                                md:gap-y-6

                                p-3
                                md:p-6

                                pb-5
                                md:pb-6
                            "
                        >

                            {activeCategoryData?.data?.dataChild?.map(
                                (item, index) => (

                                    <a
                                        key={
                                            item?.category_child_slug ||
                                            index
                                        }

                                        href={`/danh-muc-con/${item?.category_child_slug}`}

                                        className="
                                            group

                                            block

                                            text-center

                                            rounded-2xl

                                            px-1
                                            py-1

                                            md:p-3

                                            transition-all
                                            duration-200

                                            hover:bg-[#f6f9ff]
                                        "
                                    >

                                        {/* HÌNH */}
                                        <div
                                            className="
                                                mx-auto

                                                w-[70px]
                                                h-[70px]

                                                md:w-[98px]
                                                md:h-[98px]

                                                bg-[#f7f8fa]

                                                border
                                                border-gray-100

                                                rounded-2xl

                                                flex
                                                items-center
                                                justify-center

                                                overflow-hidden

                                                transition-all
                                                duration-200

                                                group-hover:bg-[#eef5ff]
                                                group-hover:border-[#dcecff]
                                                group-hover:shadow-sm
                                            "
                                        >

                                            <img
                                                src={
                                                    item?.category_child_image
                                                }
                                                alt={
                                                    item?.category_child_name
                                                }

                                                className="
                                                    w-[61px]
                                                    h-[61px]

                                                    md:w-[86px]
                                                    md:h-[86px]

                                                    object-contain

                                                    transition-transform
                                                    duration-200

                                                    group-hover:scale-[1.04]
                                                "

                                                loading="lazy"
                                            />

                                        </div>


                                        {/* TÊN */}
                                        <p
                                            className="
                                                mt-2

                                                px-0.5

                                                text-[11px]
                                                md:text-[13px]

                                                leading-[16px]
                                                md:leading-[18px]

                                                text-gray-800

                                                font-medium

                                                line-clamp-2

                                                min-h-[32px]
                                                md:min-h-[36px]
                                            "
                                        >
                                            {item?.category_child_name}
                                        </p>

                                    </a>

                                )
                            )}

                        </div>

                    )}

                </div>

            </div>
        </div>
    );
}